import { twMerge } from "tailwind-merge";

import { Switch } from "@/components/ui/switch";

interface ToggleProps {
    checked: boolean;
    handleChange: (checked: boolean) => void;
    txt?: string;
    onLabel?: string;
    offLabel?: string;
    id?: string;
    className?: string;
    switchClassName?: string;
}

export default function Toggle({
    checked,
    handleChange,
    txt,
    onLabel,
    offLabel,
    id,
    className,
    switchClassName,
}: ToggleProps) {
    return (
        <div className={twMerge("flex items-center gap-[8px]", className)}>
            <Switch
                className={twMerge(
                    "w-[48px] h-[24px] border-none data-[state=checked]:bg-console data-[state=unchecked]:bg-[#ECECEC] [&>span]:w-[18px] [&>span]:h-[18px] [&>span]:data-[state=checked]:translate-x-[27px] [&>span]:data-[state=unchecked]:translate-x-[3px]",
                    switchClassName,
                )}
                checked={checked}
                onCheckedChange={handleChange}
                id={id}
            />
            {(txt || onLabel || offLabel) && (
                <label className="cursor-pointer text-[16px] font-[400] text-[#666]" htmlFor={id}>
                    {txt ? txt : checked ? onLabel : offLabel}
                </label>
            )}
        </div>
    );
}
